import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Slider } from '../../interfaces/Slider/Slider';
import { getSliders } from '../../api/Slider';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { SlidersTable } from './SlidersTable';

export const SlidersPage = () => {
  const navigate = useNavigate();

  const [sliders, setSliders] = useState<Slider[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshSliders = () => {
    setLoading(true);
    getSliders()
      .then((s) => setSliders(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(refreshSliders, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Kaydırıcılar
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/visual/sliders/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Kaydırıcı
      </Button>
      <SlidersTable sliders={sliders} />
    </Box>
  );
};
